export default __webpack_public_path__ + "static/media/14KYCDetailsTataNeu2@2x.8b8c72f1.png";